import types from './types';
import {errorInfoConfig} from '~/misc/error-info';
import modalTypes from '~/modules/modal/types';

const initialState = {
  loading: false,
  error: false,
  verifyEmailData: {
    loading: false,
    error: false,
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case types.VERIFY_EMAIL: {
      if (action.pending) {
        return {
          ...state,
          verifyEmailData: {
            loading: true,
            error: false,
          },
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          verifyEmailData: {
            loading: false,
            error: false,
          },
        };
      }
      return {
        ...state,
        verifyEmailData: {
          loading: false,
          error: action.payload.message || action.error,
        },
      };
    }

    default:
      return state;
  }
};
export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/verify/reducer.js